export default {
    feedbacksList: document.querySelector('.swiper-wrapper'),
    // artistsList: document.querySelector('.'),
};